import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "3.429",
      d: "M24 1.714v44.572M1.714 24h44.572"
    }, null, -1)
  ]));
}
const Add = { render };
export {
  Add as default,
  render
};
//# sourceMappingURL=Add.svg.js.map
